import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
	{
		path: "/",
		name: "home",
		component: HomeView,
		meta: {
			requireAuth: false
		}
	},
	{
		path: "/about",
		name: "about",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
		meta: {
			requireAuth: false
		}
	},
	{
		path: "/products",
		name: "products",
		component: () =>
			import(/* webpackChunkName: "products" */ "../views/ProductsList.vue"),
		meta: {
			requireAuth: false
		}
	},
	{
		path: "/basket/:productId(//d+)*",
		name: "basket",
		component: () =>
			import(/* webpackChunkName: "basket" */ "../views/BasketView.vue"),
		meta: {
			requireAuth: false
		}
	},
	{
		path: "/product/:productId",
		name: "product",
		component: () =>
			import(/* webpackChunkName: "product" */ "../views/ProductView.vue"),
		meta: {
			requireAuth: false
		}
	},
	{
		path: "/guarantee",
		name: "guarantee",
		component: () =>
			import(/* webpackChunkName: "guarantee" */ "../views/GuaranteeView.vue"),
		meta: {
			requireAuth: false
		}
	},
	{
		path: "/login",
		name: "login",
		component: () =>
			import(/* webpackChunkName: "login" */ "../views/LoginPage.vue"),
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'NotFound',
		component: () =>
			import(/* webpackChunkName: "notFound" */ "../components/NotFound.vue"),
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach((to) => {
	const authParam = localStorage.getItem('authParam')
	if (to.meta.requireAuth && !authParam)
		return {
			name: 'login',
		}
})

export default router;
